import { Switch, SwitchProps } from '../Switch';
import { Typography } from '../Typography';
import {
  StyledContainer,
  StyledTitleContainer,
  StyledTopStack,
} from './SwitchWithDescriptionBox.styles';

export interface SwitchWithDescriptionBoxProps
  extends Omit<SwitchProps, 'label'> {
  readonly title: string;
  readonly description: string;
  readonly disabled?: boolean;
}

export function SwitchWithDescriptionBox({
  title,
  description,
  disabled = false,
  ...switchProps
}: SwitchWithDescriptionBoxProps) {
  return (
    <StyledContainer>
      <StyledTopStack>
        <StyledTitleContainer>
          <Typography
            color={disabled ? 'text.secondary' : 'text.primary'}
            variant="subtitle"
          >
            <strong>{title}</strong>
          </Typography>
        </StyledTitleContainer>
        <Switch disabled={disabled} noMargin {...switchProps} />
      </StyledTopStack>
      <Typography color="text.secondary" variant="caption">
        {description}
      </Typography>
    </StyledContainer>
  );
}
